// Copyright (c) 2017 Deere & Company

import AccordionList from '../state/accordion-list';
import actions from '../../action-list';
import {getDefaultState} from '../state/index';

const handleAccordion = (state, action) =>
    AccordionList.update(state, {
        accordionList: {
            $set: action.list
        }
    });

const openAccordion = (state, action) => {

    const index = state.accordionList.findIndex(item => item.accordionId === action.accordionId);

    return index >= 0 ? AccordionList.update(state, {
        accordionList: {
            [index]: {
                isExpanded: {$set: true}
            }
        }
    }) : state;

};

export default (state = getDefaultState().claimsAccordion, action) => {

    const actionTypes = {
        [actions.OPEN_ALL_CLAIMS_ACCORDION]: openAccordion,
        [actions.TOGGLE_ACCORDION]: handleAccordion
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/all-claims/reducers/toggle-accordion.js